import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import * as _ from 'lodash';

// import { AuthenticationService } from './index';
import { Comment } from '../models';
import { HttpService } from './http.service';

@Injectable()
export class VideoCommentService extends HttpService {
  // public editdata: Comment = <Comment>{};
  private comment_type: any = 1;  // 1 - video type

  getVideoComments(_filter?: object, _with?: any): Observable<Comment[]> {
    let requestOptionsArgs = { search: { comment_type: 1 } }; //1-video
    if (_with && _.isArray(_with)) {
      requestOptionsArgs.search = _.assign(requestOptionsArgs.search, { "with": _with });
    }

    return this.getApi('/comment', requestOptionsArgs, 'commentlist')
      .map(res => <Comment[]>res.json().result)
      .catch(this.handleError);
  }

  // resetEditData() {
  // this.editdata = <Comment>{};
  // }

  add(row: object): Observable<boolean> {
    row = _.assignIn({}, row);

    let requestOptionsArgs = { body: row };
    return this.postApi('/comment', requestOptionsArgs, 'add-comment')
      .map(res => {
        return res.json();
      })
      .catch(this.handleError);
  }

  edit(id: any, row: object): Observable<boolean> {
    row = _.assignIn({}, row);

    let requestOptionsArgs = { body: row };
    return this.putApi('/comment/' + id, requestOptionsArgs, 'edit-comment')
      .map(res => {
        return res.json();
      })
      .catch(this.handleError);
  }

  delete(id: string): Observable<boolean> {
    let requestOptionsArgs = {};
    return this.deleteApi('/comment/' + id, requestOptionsArgs, 'delete-comment')
      .map(res => {
        return true;
      })
      .catch(this.handleError);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/video-comment.service.ts